import connect from 'react-redux/es/connect/connect';
import ClientUserPage from '../pages/admin/clientuseredit';
import { updateGuest } from '../actions/user';

const mapStateToProps = state => ({
    loggedInUser: state.user.user
});

const mapDispatchToProps = dispatch => ({
    updateGuest: userData => {
        dispatch(updateGuest(userData));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientUserPage);
